import { API_URL } from "../config";
import BaseService from "./base-service";

export default class ControlHubService extends BaseService {
  constructor() {
    super(API_URL + "/admin");
  }

  fetchCompanyVariables(companyId) {
    return this.fetch(`/companies/${companyId}/approve_rules/variables`);
  }

  evaluateRules(companyId, variables, categories) {
    return this.post(`/companies/${companyId}/approve_rules/test_request`, {
      variables,
      categories,
    });
  }

  generatePlaidLinkToken(companyId) {
    return this.fetch(`/plaid/link-token?companyId=${companyId}`);
  }

  generatePlaidAccessToken(publicToken, companyId) {
    return this.post("/plaid/access-token", {
      public_token: publicToken,
      company_id: companyId,
    });
  }

  fetchPlaidAccounts(companyId) {
    return this.fetch(`/plaid/accounts?companyId=${companyId}`);
  }

  fetchPlaidAccountInfo(accountId, companyId) {
    return this.fetch(`/plaid/account/${accountId}?companyId=${companyId}`);
  }

  submitBankAccount(accountId, companyId) {
    return this.post(`/companies/${companyId}/submit-bank-account`, {
      account_id: accountId,
    });
  }
}
